
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getSiteSettings } from '../../api/apiServices';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const [settings, setSettings] = useState(null);
    const [fetching, setFetching] = useState(false);

  
      useEffect(() => {
          const fetchSettings = async () => {
      try {
        const res = await getSiteSettings();
        if (!res?.data) return;
        setSettings(res.data);
      } catch {
        console.log("No site settings yet");
      } finally {
          setFetching(false);
      }
    };
    fetchSettings()
        }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
        <div className="flex items-center justify-between h-24 sm:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3 cursor-pointer">
            <img
              src={settings?.logo}
              alt="Hope Restored Logo"
              className="h-16 sm:h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-[#c9a24d] cursor-pointer ${
                isActive('/') ? 'text-[#6a4bc3]' : 'text-gray-700'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-[#c9a24d] cursor-pointer ${
                isActive('/about') ? 'text-[#6a4bc3]' : 'text-gray-700'
              }`}
            >
              About Us
            </Link>
            <Link
              to="/stories"
              className={`text-sm font-medium transition-colors hover:text-[#c9a24d] cursor-pointer ${
                isActive('/stories') ? 'text-[#6a4bc3]' : 'text-gray-700'
              }`}
            >
              Impact Stories
            </Link>
            <Link
              to="/volunteer"
              className={`text-sm font-medium transition-colors hover:text-[#c9a24d] cursor-pointer ${
                isActive('/volunteer') ? 'text-[#6a4bc3]' : 'text-gray-700'
              }`}
            >
              Volunteer
            </Link>
            <Link
              to="/our-work"
              className={`text-sm font-medium transition-colors hover:text-[#c9a24d] cursor-pointer ${
                isActive('/our-work') ? 'text-[#6a4bc3]' : 'text-gray-700'
              }`}
            >
              Our Work
            </Link>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors hover:text-[#c9a24d] cursor-pointer ${
                isActive('/contact') ? 'text-[#6a4bc3]' : 'text-gray-700'
              }`}
            >
              Contact
            </Link>
          </div>

          {/* Donate Button */}
          <Link
            to="/donate"
            className="hidden lg:block bg-[#c9a24d] text-white px-6 py-2.5 rounded-full font-semibold text-sm hover:bg-[#b8923d] transition-all hover:shadow-lg hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            Donate Now
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-2xl cursor-pointer text-[#6a4bc3]"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white shadow-lg rounded-lg mt-2 py-4 px-6 mb-4">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left py-3 font-medium cursor-pointer ${
                isActive('/') ? 'text-[#6a4bc3]' : 'text-gray-700 hover:text-[#c9a24d]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left py-3 font-medium cursor-pointer ${
                isActive('/about') ? 'text-[#6a4bc3]' : 'text-gray-700 hover:text-[#c9a24d]'
              }`}
            >
              About Us
            </Link>
            <Link
              to="/stories"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left py-3 font-medium cursor-pointer ${
                isActive('/stories') ? 'text-[#6a4bc3]' : 'text-gray-700 hover:text-[#c9a24d]'
              }`}
            >
              Impact Stories
            </Link>
            <Link
              to="/volunteer"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left py-3 font-medium cursor-pointer ${
                isActive('/volunteer') ? 'text-[#6a4bc3]' : 'text-gray-700 hover:text-[#c9a24d]'
              }`}
            >
              Volunteer
            </Link>
            <Link
              to="/our-work"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left py-3 font-medium cursor-pointer ${
                isActive('/our-work') ? 'text-[#6a4bc3]' : 'text-gray-700 hover:text-[#c9a24d]'
              }`}
            >
              Our Work
            </Link>
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block w-full text-left py-3 font-medium cursor-pointer ${
                isActive('/contact') ? 'text-[#6a4bc3]' : 'text-gray-700 hover:text-[#c9a24d]'
              }`}
            >
              Contact
            </Link>
            <Link
              to="/donate"
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-full mt-4 bg-[#c9a24d] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#b8923d] transition-colors whitespace-nowrap cursor-pointer block text-center"
            >
              Donate Now
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
